import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import { Solution, SolutionState } from "../../types/Solutions";
import Api from "../../network/Api";
import Summary from "./Summary";
import { Box, Card, Container, FormGroup, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Stack } from "@mui/material";
import User from "../../types/User";
import Placeholder from "../Shared/Placeholder";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CommentBox from "../Comments/CommentBox";
import Toolbar from "./Toolbar";


type SolutionParams = {
  mitigation?: string;
  approver?: User | string;
};

const Show = (props: { id: string, user: User }) => {

  const [solution, setSolution] = useState<Solution>();
  const [params, setParams] = useState<SolutionParams>({});

  useEffect(() => {
    Api.get(`/solutions/${props.id}`).then(setSolution);
  }, []);

  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [editable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
      if (typeof(solution) === "undefined") { return }
      setParams({...params, ...solution});
      setIsEditable(SolutionState[solution.state] !== SolutionState.resolved);
    }, [solution]);

  const save = (params: SolutionParams) => {
    setIsUpdating(true);
    Api.put(`/solutions/${solution?.id}`, params).then(result => {
      setSolution(result);
      setIsUpdating(false);
    });
  };

  return <Box sx={{flex: 1, overflowY: 'auto', py: 3, width: "100%"}}>
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 8}}>
          <Card>
            { solution ? <Summary solution={solution} 
                                  editable={editable}
                                  onChange={object => setParams({...params, ...object})}
                                  onSave={save} /> : <Placeholder /> }
          </Card>
        </Grid>

        <Grid size={{xs: 12, md: 4}}>
          <Stack spacing={3}>

            <Paper sx={{p: 3}}>{ solution ? <>
              <FormGroup>
                <p><strong>Solution state</strong></p>
              </FormGroup>
              <Toolbar solution={solution}
                       user={props.user}
                       isUpdating={isUpdating}
                       onChange={object => setParams({...params, ...object})}
                       onSave={save} />
              </> : <Placeholder /> }
            </Paper>

            <Paper sx={{p: 3}}>{ solution ? <>
              <FormGroup>
                <p><strong>Linked issues</strong></p>
                <List>
                  { solution.lessons.map(lesson => {
                    return <ListItem key={lesson.id} sx={{p: "0 !important"}}>
                      <ListItemText>
                        <ListItemButton component={NavLink} to={`/lessons/${lesson.id}`} sx={{p: "0.5rem 1rem !important"}}>
                          <ListItemIcon sx={{minWidth: '0 !important', mr: 2}}><AccountTreeIcon color="secondary" fontSize="small" /></ListItemIcon>
                          {lesson.headline}
                        </ListItemButton>
                      </ListItemText>
                    </ListItem>
                  }) }
                </List>
              </FormGroup>
              </> : <Placeholder /> }
            </Paper>

            <Paper sx={{p: 3}}>{ solution ? <>
              <FormGroup>
                <p><strong>Comments</strong></p>
              </FormGroup>                  
              <CommentBox user={props.user} solution={solution} />
              </> : <Placeholder /> }
            </Paper>

          </Stack>
        </Grid>
      </Grid>
    </Container>
  </Box>
}

export default Show;